import {useRef, useState, useEffect} from 'react'
import { Pencil, ArrowLeftRight, Upload, Save, House, Download, Trash2, Table2, Columns } from 'lucide-react'
import sidebarlogo from '../../assets/img/sidebarlogo.svg'
import {AddProductSdebar} from './AddProductSdebar'
import {MoverProductSidebar} from './MoverProductSidebar'
import {ActivateSidebar} from './ActivateSidebar'
import {GuadarProductSidebar} from './GuadarProductSidebar'
import {InicioPop} from './InicioPop'
import {InicioPop3} from './InicioPop3'
import {InicioPop2} from './InicioPop2'
import {DeleteProductSidebar} from './DeleteProductSidebar'
import {ExportProductSidebar} from './ExportProductSidebar'
import { useParams } from 'react-router-dom'

export const LegendColumnRight = ({HeightStateRight, secondActive = null, setLegendColumns, legendColumns,
promotion, setIdProductoEliminar, setAccionGuardar, movimientos, setInicioPopStateEliminar,setIdEliminar,
textoValidacion, aprobarMovimiento, validacion, setSimulacionPage,toggleSimulacionPage, simulacionPage,
setDownloadCSV, csvLinkRef, setTypePromotion, typePromotion, setCargaMasiva, setModalProduct, setDataProduct, setChangeColumn
	, viewPage, setRejectReasonProduct, catalogViewMode = 'columns', setCatalogViewMode
}) => {
	// console.log("PROMOCION DATA PROMOCION!!!!!!!!!!!!!! ");
	// console.log(promotion);
	const [state, setState] = useState(1) // secondActive ? 2 : 1
	const [currentOption, setcurrentOption] = useState(1) // secondActive ? 2 : 1
	const [svg, setSvg] = useState(1)
	const [afterstate, setafterState] = useState(null)
	const [frontBar, setfrontBar] = useState(32)
	const [InicioPopState, setInicioPopState] = useState(null)
	const {idPromocion, estadoPromocion} = useParams()
	const rol = localStorage.getItem('rol')
	const isAdminRole = rol === 'ADMIN' || rol === 'SUPER ADMIN'
	const disableAddAndMassiveLoad = estadoPromocion !== '1' && !isAdminRole
	const estadoPromocionNum = Number(estadoPromocion)
	const disableMoveSaveDiscard = !isAdminRole && estadoPromocionNum >= 13 && estadoPromocionNum <= 17
	const isExecutionState = estadoPromocionNum >= 13 && estadoPromocionNum <= 17
	const isViewMode = String(viewPage) === '1'
	const disableByViewMode = isViewMode

	const ref = useRef(null)

	const handleDocumentClick = (event) => {
		const container = document.querySelector('.LegendColumnRight');
        if (container && !container.contains(event.target)) {
			actionNormalMenu();
        }
    };

	const actionNormalMenu = () => {
		setfrontBar(32)
		setafterState(null)
		setSvg(1)
		setTimeout(() => {
			setcurrentOption(null)
		}, 200)
		// setcurrentOption(null)
	}

	const getArrowTop = (e) => {
		const bar = document.querySelector('.beforebar')
		const icon = e.currentTarget
		const barRect = bar.getBoundingClientRect()
		const iconRect = icon.getBoundingClientRect()
		return Math.round(iconRect.top - barRect.top + iconRect.height / 2) - 7
	}

	

	useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, []);
	
	return (
		<div
			className='LegendColumnRight'
			style={{height: `${HeightStateRight}px`}}
			// ref={ref}
		>
			{InicioPopState === 1 && (
				<InicioPop setInicioPopState={setInicioPopState} setAccionGuardar={setAccionGuardar}
				/>
			)}
			{InicioPopState === 2 && (
				<InicioPop2 setInicioPopState={setInicioPopState} />
			)}
			{InicioPopState === 3 && (
				<InicioPop3 setInicioPopState={setInicioPopState} />
			)}
			<div
				className={`front-bar front-bar-first ${state === 1 && 'bluebar'}  ${
					state === 1 && 'come-out'
				}
				${svg === 2 && 'bluebarno'}`}
				style={{width: `${frontBar}px`}}
				
			>
				{svg === 2 && (
					<svg
						width='32'
						
						onClick={(e) => {
							
							setSimulacionPage(false)
							toggleSimulacionPage(false)
							setfrontBar(32)
							setafterState(null)
							setSvg(1) 
							/*
							if((estadoPromocion === '1' || estadoPromocion === '3') || localStorage.getItem('rol') === 'SUPER ADMIN'){
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								setfrontBar(32)
								setafterState(null)
								setSvg(1)
							}else{
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								// setfrontBar(564)
								// setSvg(2)
								// setafterState(1)
								// setcurrentOption(1)
							} */
						}}
						height='32'
						viewBox='0 0 32 32'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							fill='#F0F4FC'
						/>
						<g clipPath='url(#clip0_2_689958)'>
							<mask
								id='mask0_2_689958'
								maskUnits='userSpaceOnUse'
								x='4'
								y='4'
								width='24'
								height='24'
							>
								<rect x='4' y='4' width='24' height='24' fill='#D9D9D9' />
							</mask>
							<g mask='url(#mask0_2_689958)'>
								<path
									d='M10.0001 17.1501C9.68343 17.1501 9.41276 17.0374 9.1881 16.8121C8.96276 16.5874 8.8501 16.3168 8.8501 16.0001C8.8501 15.6834 8.96276 15.4128 9.1881 15.1881C9.41276 14.9628 9.68343 14.8501 10.0001 14.8501H22.0001C22.3168 14.8501 22.5874 14.9628 22.8121 15.1881C23.0374 15.4128 23.1501 15.6834 23.1501 16.0001C23.1501 16.3168 23.0374 16.5874 22.8121 16.8121C22.5874 17.0374 22.3168 17.1501 22.0001 17.1501H10.0001Z'
									fill='#3676F5'
								/>
							</g>
						</g>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							stroke='#3676F5'
						/>
						<defs>
							<clipPath id='clip0_2_689958'>
								<rect
									width='24'
									height='24'
									fill='white'
									transform='translate(4 4)'
								/>
							</clipPath>
						</defs>
					</svg>
				)}
				{svg === 1 && (
					<svg 
						className='show-toolbar'
						onClick={(e) => {
							if((estadoPromocion === '1' || estadoPromocion === '3') || localStorage.getItem('rol') === 'SUPER ADMIN'){
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								setfrontBar(564)
								setSvg(2)
								setafterState(1)
								setcurrentOption(1)
							}else{
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								// setfrontBar(564)
								// setSvg(2)
								// setafterState(1)
								// setcurrentOption(1)
							}
						}}
						
						width='32'
						height='32'
						viewBox='0 0 32 32'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							fill='#F0F4FC'
						/>
						<g clipPath='url(#clip0_655_226987)'>
							<mask
								id='mask0_655_226987'
								maskUnits='userSpaceOnUse'
								x='4'
								y='4'
								width='24'
								height='24'
							>
								<rect x='4' y='4' width='24' height='24' fill='#D9D9D9' />
							</mask>
							<g mask='url(#mask0_655_226987)'>
								<path
									d='M16.0001 23.15C15.6834 23.15 15.4128 23.0373 15.1881 22.812C14.9628 22.5873 14.8501 22.3166 14.8501 22V17.15H10.0001C9.68343 17.15 9.41276 17.0373 9.1881 16.812C8.96276 16.5873 8.8501 16.3166 8.8501 16C8.8501 15.6833 8.96276 15.4126 9.1881 15.188C9.41276 14.9626 9.68343 14.85 10.0001 14.85H14.8501V9.99998C14.8501 9.68331 14.9628 9.41231 15.1881 9.18698C15.4128 8.96231 15.6834 8.84998 16.0001 8.84998C16.3168 8.84998 16.5874 8.96231 16.8121 9.18698C17.0374 9.41231 17.1501 9.68331 17.1501 9.99998V14.85H22.0001C22.3168 14.85 22.5874 14.9626 22.8121 15.188C23.0374 15.4126 23.1501 15.6833 23.1501 16C23.1501 16.3166 23.0374 16.5873 22.8121 16.812C22.5874 17.0373 22.3168 17.15 22.0001 17.15H17.1501V22C17.1501 22.3166 17.0374 22.5873 16.8121 22.812C16.5874 23.0373 16.3168 23.15 16.0001 23.15Z'
									fill='#3676F5'
								/>
							</g>
						</g>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							stroke='#3676F5'
						/>
						<defs>
							<clipPath id='clip0_655_226987'>
								<rect
									width='24'
									height='24'
									fill='white'
									transform='translate(4 4)'
								/>
							</clipPath>
						</defs>
					</svg>
				)}
				<div className='tooltip-plus'>
					<p>Haz click aquí para agregar productos</p>
				</div>
				{afterstate === 1 && <AddProductSdebar setLegendColumns={setLegendColumns}
        legendColumns={legendColumns}
        promotion={promotion}
        setIdProductoEliminar={setIdProductoEliminar}
		setInicioPopState={setInicioPopStateEliminar}
		setIdEliminar={setIdEliminar}
		actionNormalMenu={actionNormalMenu}
		setModalProduct={setModalProduct}
		setDataProduct={setDataProduct}
		setRejectReasonProduct={setRejectReasonProduct}
		setChangeColumn={setChangeColumn}
        />}
			</div>
			<div className={`front-bar ${afterstate === 3 && 'come-out'} `}>
				{afterstate === 3 && <MoverProductSidebar movimientos={movimientos} 
				promotion={promotion} setAccionGuardar={setAccionGuardar}
				setafterState={setafterState}
				setSvg={setSvg}
				aprobarMovimiento={aprobarMovimiento}
				textoValidacion={textoValidacion}
				validacion={validacion}
				actionNormalMenu={actionNormalMenu}
				simulacionPage={simulacionPage}
				setSimulacionPage={setSimulacionPage}
				/>}
			</div>
			<div className={`front-bar ${afterstate === 4 && 'come-out'} `}>
				{afterstate === 4 && <ActivateSidebar />}
			</div>
			<div className={`front-bar ${afterstate === 5 && 'come-out'} `}>
				{afterstate === 5 && <GuadarProductSidebar setAccionGuardar={setAccionGuardar}
				setafterState={setafterState}
				setfrontBar={setfrontBar}
				setSvg={setSvg}
				textoValidacion={textoValidacion}
				actionNormalMenu={actionNormalMenu}
				simulacionPage={simulacionPage}
				setSimulacionPage={setSimulacionPage}
								/>}
			</div>
			<div className={`front-bar ${afterstate === 7 && 'come-out'} `}>
				{afterstate === 7 && <ExportProductSidebar 
				actionMenuNormal={actionNormalMenu}
				setDownloadCSV={setDownloadCSV}
				csvLinkRef={csvLinkRef}
				idPromocion={idPromocion}
				showSapExcelOption={isExecutionState}
				typePromotion={typePromotion}
				/>}
			</div>
			<div className={`front-bar ${afterstate === 8 && 'come-out'} `}>
				{afterstate === 8 && <DeleteProductSidebar 
				movimientos={movimientos} 
				promotion={promotion}
				actionNormalMenu={actionNormalMenu}
				/>}
			</div>
			<div className='beforebar'>
				<span ref={ref} style={secondActive ? {top: 78} : {}}></span>
				<div className='top-area'>
					<div 
						id={"botonAgregar"}
						className={`icon ${currentOption === 1 && 'active'} ${(disableAddAndMassiveLoad || disableByViewMode) ? 'disabled' : ''}`}
						onClick={(e) => {
							if (disableAddAndMassiveLoad || disableByViewMode) {
								return
							}
							
							if(currentOption === 1){
								actionNormalMenu()
								setcurrentOption(null)
							}else{
								if(simulacionPage){
									console.log("okok")
									setfrontBar(32)
									setafterState(null)
									setSvg(1)
									setcurrentOption(null)
									
								}else{
									
									/*
									setSvg(2)
									setcurrentOption(1)
									setafterState(1)
									setfrontBar(564)
									setState(1) */

									if((estadoPromocion === '1' || estadoPromocion === '3') || localStorage.getItem('rol') === 'SUPER ADMIN'){
										setSvg(2)
										setcurrentOption(1)
										setafterState(1)
										setfrontBar(564)
										setState(1)
									}else{
										setSvg(2)
										setcurrentOption(1)
										// setafterState(1)
										// setfrontBar(564)
										setState(1)
									}
								}
								
								// setfrontBar(564)
								
								ref.current.style.top = `${getArrowTop(e)}px`
							}
							setSimulacionPage(false)							
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Agregar Productos</p>
						</div>
						<Pencil size={16} color="#3676f5" />
					</div>

					<div
						className={`icon ${currentOption === 2 && 'active'}`}
						onClick={(e) => {
							setafterState(2)
							setState(null)
							setcurrentOption(2)
							ref.current.style.top = `${getArrowTop(e)}px`
							// window.location.pathname = '/simulacion/'+promotion.data_promocion.id
							setSimulacionPage(true)
							toggleSimulacionPage(true)
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Ir a Revisión</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_640_241607)'>
								<mask
									id='mask0_640_241607'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_640_241607)'>
									<path
										d='M2.58346 16.75C2.06957 16.75 1.63568 16.5727 1.28179 16.2183C0.927344 15.8644 0.750122 15.4305 0.750122 14.9166C0.750122 14.4166 0.930678 13.9897 1.29179 13.6358C1.6529 13.2814 2.08346 13.1041 2.58346 13.1041H2.82346C2.89957 13.1041 2.97234 13.118 3.04179 13.1458L6.56262 9.6458C6.53484 9.56247 6.52096 9.48247 6.52096 9.4058V9.16664C6.52096 8.66664 6.69818 8.23941 7.05262 7.88497C7.40651 7.53108 7.83346 7.35414 8.33346 7.35414C8.83346 7.35414 9.26068 7.53108 9.61512 7.88497C9.96901 8.23941 10.146 8.66664 10.146 9.16664C10.146 9.22219 10.1321 9.37497 10.1043 9.62497L12.0418 11.5625C12.1251 11.5347 12.2015 11.5208 12.271 11.5208H12.7401C12.8162 11.5208 12.889 11.5347 12.9585 11.5625L15.646 8.87497C15.6182 8.80552 15.6043 8.73247 15.6043 8.6558V8.41664C15.6043 7.91664 15.7815 7.48608 16.136 7.12497C16.4898 6.76386 16.9168 6.5833 17.4168 6.5833C17.9307 6.5833 18.3648 6.76025 18.7193 7.11414C19.0732 7.46858 19.2501 7.90275 19.2501 8.41664C19.2501 8.91664 19.0696 9.34358 18.7085 9.69747C18.3473 10.0519 17.9168 10.2291 17.4168 10.2291H17.1776C17.101 10.2291 17.0279 10.2152 16.9585 10.1875L14.271 12.875C14.2987 12.9444 14.3126 13.0172 14.3126 13.0933V13.3333C14.3126 13.8333 14.1357 14.2605 13.7818 14.615C13.4273 14.9689 13.0001 15.1458 12.5001 15.1458C12.0001 15.1458 11.5732 14.9689 11.2193 14.615C10.8648 14.2605 10.6876 13.8333 10.6876 13.3333V13.0933C10.6876 13.0172 10.7015 12.9375 10.7293 12.8541L8.81262 10.9375C8.72929 10.9652 8.64957 10.9791 8.57346 10.9791H8.33346C8.2779 10.9791 8.12512 10.9652 7.87512 10.9375L4.35429 14.4583C4.38207 14.5416 4.39596 14.618 4.39596 14.6875V14.9166C4.39596 15.4166 4.21901 15.8472 3.86512 16.2083C3.51068 16.5694 3.08346 16.75 2.58346 16.75ZM3.33346 8.43747L2.77096 7.22914L1.56262 6.66664L2.77096 6.10414L3.33346 4.8958L3.89596 6.10414L5.10429 6.66664L3.89596 7.22914L3.33346 8.43747ZM12.5001 7.68747L11.646 5.85414L9.81262 4.99997L11.646 4.1458L12.5001 2.31247L13.3543 4.1458L15.1876 4.99997L13.3543 5.85414L12.5001 7.68747Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_640_241607'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					<div id={"botonMover"}
						className={`icon ${currentOption === 3 ? 'active' : ''} ${(disableMoveSaveDiscard || disableByViewMode) ? 'disabled' : ''}`}
						onClick={(e) => {
							if (disableMoveSaveDiscard || disableByViewMode) {
								return
							}
							if(estadoPromocion !== '5' && estadoPromocion !== '7' && estadoPromocion !== '9'){
								if(currentOption === 3){
									actionNormalMenu()
									setcurrentOption(null)
								}else{
									setafterState(3)
									setcurrentOption(3)
									setState(3)
									ref.current.style.top = `${getArrowTop(e)}px`
								}
							}

						}}
					>
						<div className='tooltip-sidebar'>
							<p>Mover</p>
						</div>
						<ArrowLeftRight size={16} color="#3676f5" />
					</div>
					<div
						className={`icon ${currentOption === 2 && ''}`}
						onClick={(e) => {
							// setafterState(2)
							// setState(null)
							// setcurrentOption(2)
							ref.current.style.top = `${getArrowTop(e)}px`
							// window.location.pathname = '/simulacion/'+promotion.data_promocion.id
							// setSimulacionPage(true)
							// toggleSimulacionPage(true)
							if(typePromotion === "SELL-IN"){
								setTypePromotion("SELL-OUT")
							}else{
								setTypePromotion("SELL-IN")
							}
						}}
						style={{color: "#3676f5", fontWeight: 700}}
					>
						<div className='tooltip-sidebar'>
							<p>Cambiar Tipo de Promoción</p>
						</div>
						{typePromotion === "SELL-IN" ? "SO":"SI"}
					</div>

					
					
					<div
						className={`icon ${currentOption === 112 && 'active'} ${(disableAddAndMassiveLoad || disableByViewMode) ? 'disabled' : ''}`}
						onClick={(e) => {
							if (disableAddAndMassiveLoad || disableByViewMode) {
								return
							}
							// setafterState(2)
							// setState(null)
							setcurrentOption(112)
							ref.current.style.top = `${getArrowTop(e)}px`
							// window.location.pathname = '/simulacion/'+promotion.data_promocion.id
							// setSimulacionPage(true)
							// toggleSimulacionPage(true)
							setCargaMasiva(true)
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Carga Masiva</p>
						</div>
						<Upload size={16} color="#3676f5" />
					</div>

					<div
						className={`icon ${catalogViewMode === 'table' && 'active'}`}
						onClick={(e) => {
							setCatalogViewMode((prevMode) => prevMode === 'table' ? 'columns' : 'table')
							actionNormalMenu()
						}}
					>
						<div className='tooltip-sidebar'>
							<p>{catalogViewMode === 'table' ? 'Vista Columnas' : 'Vista Tabla'}</p>
						</div>
						{catalogViewMode === 'table' ? (
							<Columns size={16} color="#3676f5" />
						) : (
							<Table2 size={16} color="#3676f5" />
						)}
					</div>

					
					

				</div>
				<div className='middle-area'>
				{ /*
					<div
						className={`icon ${currentOption === 4 && 'active'}`}
						onClick={(e) => {
							setafterState(4)

							setcurrentOption(4)
							setState(4)
							ref.current.style.top = `320px`
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Actividad</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_655_229416)'>
								<mask
									id='mask0_655_229416'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_655_229416)'>
									<path
										d='M5.41667 13.5208C6.06944 13.5208 6.705 13.5938 7.32333 13.74C7.94111 13.8855 8.55556 14.1041 9.16667 14.3958V6.18746C8.59722 5.85413 7.99306 5.60413 7.35417 5.43746C6.71528 5.27079 6.06944 5.18746 5.41667 5.18746C4.91667 5.18746 4.42028 5.23607 3.9275 5.33329C3.43417 5.43051 2.95833 5.57635 2.5 5.77079V14.0208C2.98611 13.8541 3.46889 13.7291 3.94833 13.6458C4.42722 13.5625 4.91667 13.5208 5.41667 13.5208ZM10.8333 14.3958C11.4444 14.1041 12.0592 13.8855 12.6775 13.74C13.2953 13.5938 13.9306 13.5208 14.5833 13.5208C15.0833 13.5208 15.5731 13.5625 16.0525 13.6458C16.5314 13.7291 17.0139 13.8541 17.5 14.0208V5.77079C17.0417 5.57635 16.5661 5.43051 16.0733 5.33329C15.58 5.23607 15.0833 5.18746 14.5833 5.18746C13.9306 5.18746 13.2847 5.27079 12.6458 5.43746C12.0069 5.60413 11.4028 5.85413 10.8333 6.18746V14.3958ZM10.0208 16.5833C9.8125 16.5833 9.61806 16.5588 9.4375 16.51C9.25694 16.4616 9.09028 16.3958 8.9375 16.3125C8.39583 15.993 7.83 15.75 7.24 15.5833C6.64944 15.4166 6.04167 15.3333 5.41667 15.3333C4.84722 15.3333 4.28472 15.4097 3.72917 15.5625C3.17361 15.7152 2.64583 15.9305 2.14583 16.2083C1.8125 16.375 1.48611 16.3647 1.16667 16.1775C0.847222 15.9897 0.6875 15.7083 0.6875 15.3333V5.31246C0.6875 5.10413 0.732778 4.91329 0.823333 4.73996C0.913333 4.56607 1.05556 4.43051 1.25 4.33329C1.88889 4.01385 2.55917 3.77079 3.26083 3.60413C3.96194 3.43746 4.67361 3.35413 5.39583 3.35413C6.21528 3.35413 7.01056 3.45829 7.78167 3.66663C8.55222 3.87496 9.29167 4.1944 10 4.62496C10.7083 4.20829 11.4481 3.89218 12.2192 3.67663C12.9897 3.46163 13.7847 3.35413 14.6042 3.35413C15.3264 3.35413 16.0381 3.43746 16.7392 3.60413C17.4408 3.77079 18.1111 4.01385 18.75 4.33329C18.9444 4.43051 19.0869 4.56607 19.1775 4.73996C19.2675 4.91329 19.3125 5.10413 19.3125 5.31246V15.4166C19.3125 15.7777 19.1564 16.045 18.8442 16.2183C18.5314 16.3922 18.2014 16.3888 17.8542 16.2083C17.3542 15.9305 16.8264 15.7152 16.2708 15.5625C15.7153 15.4097 15.1528 15.3333 14.5833 15.3333C13.9583 15.3333 13.3542 15.4166 12.7708 15.5833C12.1875 15.75 11.6319 15.993 11.1042 16.3125C10.9375 16.3958 10.7639 16.4616 10.5833 16.51C10.4028 16.5588 10.2153 16.5833 10.0208 16.5833Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_655_229416'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					*/ }
					<div
						className={`icon ${currentOption === 5 && 'active'} ${(disableMoveSaveDiscard || disableByViewMode) ? 'disabled' : ''}`}
						onClick={(e) => {
								if (disableMoveSaveDiscard || disableByViewMode) {
									return
								}
								
								if(currentOption === 5){
									actionNormalMenu()
									setcurrentOption(null)
								}else{
									// Ver opción después de bloquear de acuerdo a ciertos estados y tipos de usuarios
									setfrontBar(32)
									setafterState(null)
									setSvg(1)
									setafterState(5)
									setcurrentOption(5)
									setState(5)
								}
							

							ref.current.style.top = `${getArrowTop(e)}px`
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Guardar</p>
						</div>
						<Save size={16} color="#3676f5" />
					</div>

					<div
						className={`icon ${currentOption === 6 && 'active'}`}
						onClick={(e) => {
							
							setfrontBar(32)
							setafterState(6)

							setcurrentOption(6)
							setState(6)
							setInicioPopState(1)
							ref.current.style.top = `${getArrowTop(e)}px`
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Ir al Inicio</p>
						</div>
						<House size={16} color="#3676f5" />
					</div>
					
					<div
						className={`icon ${currentOption === 7 && 'active'}`}
						onClick={(e) => {
							setafterState(7)
							setcurrentOption(7)
							setState(7)
							ref.current.style.top = `${getArrowTop(e)}px`
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Exportar</p>
						</div>
						<Download size={16} color="#3676f5" />
					</div>
					<div
						className={`icon delete ${currentOption === 8 && 'active'} ${(disableMoveSaveDiscard || disableByViewMode) ? 'disabled' : ''}`}
						onClick={(e) => {
							if (disableMoveSaveDiscard || disableByViewMode) {
								return
							}
							
							if(currentOption === 8){
								actionNormalMenu()
								setcurrentOption(null)
							}else{
							setafterState(8)
							setcurrentOption(8)
							setState(8)
							ref.current.style.top = `${getArrowTop(e)}px`
							}
						}}
					>
						<div className='tooltip-sidebar danger'>
							<p>Descartar</p>
						</div>
						<Trash2 size={16} color="#FF5334" />
					</div>
				</div>
				<img src={sidebarlogo} className='sidebarlogo' alt='' />
			</div>
		</div>
	)
}
